import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  Tooltip, Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function BarChartCard({ title, labels, data }) {
  const chartData = {
    labels,
    datasets: [{ label: "Errors", data }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: true } },
  };

  return (
    <div className="card shadow-sm h-100">
      <div className="card-body">
        <div className="fw-semibold mb-2">{title}</div>
        <div style={{ height: 280 }}>
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
}